module.exports = __webpack_public_path__ + "static/media/project_empty_circle1@2x.c5cf36c6.png";